import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import ProductItemModel from 'coreClasses/basket/ProductItemModel';
import {ReturnOrderProductData} from 'coreClasses/returnAuthorization/IReturnOrderData';
import ReturnReasonModel from 'coreClasses/returnAuthorization/ReturnReasonModel';
import {useProducts} from 'coreHooks';
import AddressModel from 'coreOrderModels/AddressModel';
import ShipmentModel from 'coreOrderModels/ShipmentModel';

import Button from 'brandComponents/Button';
import {ProductData} from 'brandComponents/ReturnAuthorizationCreateForm/Subcomponents';

import {IStep2ProductsProps} from './IStep2Products';
import messages from './messages';

import step2Styles from './../../Step2.module.scss';
import styles from './Step2Products.module.scss';

const Step2Products = ({
	returnOrder,
	returnOrderData,
	returnReasons,
	exchangeReasons,
	goToStep,
	step,
}: IStep2ProductsProps) => {
	const intl = useIntl();

	const shipment: ShipmentModel = returnOrder.getShipments()?.[0] || null;
	const shippingAddress: AddressModel = shipment?.getShippingAddress() || null;

	const productsToReturn: ProductItemModel[] = useMemo(() => {
		let products = [];
		returnOrderData.getProducts().forEach((product: ReturnOrderProductData) => {
			products.push(returnOrder.getProductItem(product.lineItemID));
		});

		return products;
	}, [returnOrderData]);

	const prodIdList = productsToReturn.map((el) => el.getProductId());
	const products = useProducts(prodIdList);

	const reasonMatcher = (product) => {
		let reasonCode = '';
		let reason: ReturnReasonModel;

		if ('exchangeReason' in product) {
			reasonCode = product.exchangeReason;
			reason = exchangeReasons.find((element) => element.getValue() === reasonCode);
		} else {
			reasonCode = product.returnReason;
			reason = returnReasons.find((element) => element.getValue() === reasonCode);
		}

		return reason ? reason.getLabel() : '';
	};

	return (
		<div className={styles['return-create-step-2__products']}>
			<div className={styles['return-create-step-2__products-title-wrapper']}>
				<span className={styles['return-create-step-2__products-title']}>
					{intl.formatMessage(messages.productsToReturn)}
				</span>
				<Button variant="tertiary" classNames={step2Styles['modify-btn']} onClick={() => goToStep(1)}>
					{intl.formatMessage(messages.modifyButtonText)}
				</Button>
			</div>
			{productsToReturn.map((item, index) => (
				<div className={styles['return-create-step-2__product-data-wrapper']} key={item.getItemId()}>
					<ProductData
						reasonToReturn={reasonMatcher(returnOrderData.getProducts()[index])}
						item={item}
						product={products[index]}
						shippingCountryCode={shippingAddress?.getCountryCode()}
						quantity={1}
						currency={returnOrder.getCurrency()}
						step={step}
						isExchange={returnOrderData.getProducts()[index].isExchange}
					/>
				</div>
			))}
		</div>
	);
};

export default Step2Products;
